import { Button, Grid, TextField, Typography } from '@mui/material';
import React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import SubCard from 'ui-component/cards/SubCard';
const SearchFilter = (props) => {
  return (
    <SubCard>
      <Grid container justifyContent="space-between">
        <Grid item md={6} xs={12}>
          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              <Typography variant='h5' sx={{color:"#20415C",marginBottom:1}} fontWeight={600} >Search</Typography>
              <TextField
                id="outlined-basic"
                name="search"
                value={props.filter && props.filter.value}
                variant="outlined"
                fullWidth
                size="small"
                onChange={(e)=>props.handleChange("value",e.target.value)}
                sx={{
                    '& .MuiOutlinedInput-root': {
                      border: '2px solid #A9A9A980 50%', // change border color
                      borderRadius: '8px',
                    },
                    '& fieldset': {
                        borderColor: '#A9A9A980', 
                        borderRadius:'8px'// default border color
                    },  
                  }}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <Box sx={{ minWidth: 120 }}>
                <FormControl fullWidth size="small">
              <Typography variant='h5' sx={{color:"#20415C",marginBottom:1}} fontWeight={600} >Category</Typography>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="category"
                    value={props.filter && props.filter.category}
                    onChange={(e)=>props.handleChange("category",e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-notchedOutline': {
                        border: '2px solid #A9A9A980 50%', // change border color
                        borderRadius: '8px', // change border radius
                      },
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        border: '2px solid #A9A9A980 50%', // change border color
                      },
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        border: '2px solid #A9A9A980 50%', // change border color
                      },
                    }}
                  >
                    <MenuItem value={'application_id'}>Application ID</MenuItem>
                    <MenuItem value={'csp_code'}>CSP Code</MenuItem>
                    <MenuItem value={'agent_name'}>CSP Name</MenuItem>
                    <MenuItem value={'agent_code'}>Agent Code</MenuItem>
                    {/* <MenuItem value={'ds_name'}>DS Name</MenuItem> */}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={2} xs={12}>
            <Typography variant="h4" gutterBottom sx={{visibility:'hidden'}}>temp</Typography>
          <Grid container spacing={2}>
            <Grid item md={6} xs={12}>
              <Button 
                fullWidth 
                variant="contained" 
                color="primary" 
                onClick={props.handleSearch}
                sx={{
                    backgroundColor:"#688B2A",
                    color:"#fff",
                    borderRadius:"10px",
                    '&:hover': {
                      backgroundColor: "#688B3A",
                      color:"#fff",
                      borderRadius:"10px",
                    },
                    }}
                >
                Search
              </Button>
            </Grid>
            <Grid item md={6} xs={12}>
              <Button fullWidth variant="contained" color="secondary" onClick={props.handleFilterClear} sx={{borderRadius:"10px"}}>
                Clear
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </SubCard>
  );
};

export default SearchFilter;
